import { createFileRoute, redirect } from "@tanstack/react-router";

import { getCachedWidgetConfig } from "../../features/customization/utils/config-loader";
import { getPreferredStakingAsset } from "../../features/staking/utils/staking-routing";

export const Route = createFileRoute("/_layout/staking/")({
  beforeLoad: () => {
    const stakingConfig = getCachedWidgetConfig()?.features?.staking;
    const defaultAsset = stakingConfig
      ? getPreferredStakingAsset(stakingConfig, false) || "eth"
      : "eth";

    throw redirect({
      to: "/staking/$asset",
      params: { asset: defaultAsset },
    });
  },
});
